export default __webpack_public_path__ + "static/media/Floor4MintTowerBuildingMain.032c2753.svg";